<template>
    <div>

        <p>
            Type

            <b-select v-model="type" :options="[
                { text: 'Profil', value: 'profil' },
                { text: 'Entreprise', value: 'entreprise' }
            ]"></b-select> 
        </p>

        Colonne des urls
        <b-input :list="'columns' + id" v-model="column" />
        <datalist :id="'columns' + id">
            <option v-for="(option, idx) in columns_data" :key="'c' + idx">{{ option }}</option>
        </datalist>
    </div>
</template>

<script>
    import uniqueId from "lodash.uniqueid";

    var clone = require("clone");
    
    export default {
        name: "linkedin",
		components: {
		},
		props: {
            treatment_params: {
                default: false
            },
            files: {
                default: () => []
            },
			data: {
				default: () => [],
            },
			client: {
				default: null
            },
            size: {
                default: 1000
            },
			step_position: {
				default: 0
			}
        },
        watch: 
        {
            data: {
                deep: true,
                immediate: true,
                handler()
                {
                    if (this.data.length != 0)
                    {
                        this.columns_data = Object.keys(this.data[0]);
                    }
                }
            },
            files: {
                deep: true,
                immediate: true,
                handler()
                {
                    //console.log(this.files);

                    if (this.files.length > 0)
                    {
                        var self = this;
                        var reader = new FileReader();

                        reader.onload = (function (theFile) {
                            return function (e) {
                                if (e.target.result)
                                {
                                    var data = self.$papa.parse(e.target.result, { header: true });
                                    if (data.data && data.data.length > 0)
                                    {
                                        self.columns_data = Object.keys(data.data[0]);
                                    }
                                }
                            };
                        })(this.files[0].file ? this.files[0].file : this.files[0]);

                        reader.readAsText(this.files[0].file ? this.files[0].file : this.files[0]);
                    }
                }
            }
        },
        computed: {
            
        },
		data() {
			return {
                id: uniqueId(""),
                column: "",
                type: "profil"
			};
        },
        methods: {
            get_data()
            {
                return this.save()
            },
            save()
            {
                console.log("save");

                var data = {
                    column: this.column,
                    type: this.type
                }

                return data;
            },
            async load(data)
            {
                var self = this;
                
                if (!data)
                {
                    return;
                }

                this.column = data.column;
                this.type = data.type ? data.type : "profil";
            },
        },
        async mounted()
        {
        }
    }
</script>

<style scoped>
</style>